import React from 'react';

import Icon from 'components/generic/Icon.component';
import S from 'constants/string.const';

import CN from './TableRates.module.scss';

const TablePayment = () => (
  <div data-bem="TablePayment" className={CN.component}>
    <table className={CN.table}>
      <thead>
        <tr>
          <th>
            <div className={CN.tableHeader}>
              <Icon variant="moneyPaper" width="lg" /> <div className={CN.headerText}>Payment date</div>
            </div>
          </th>
          <th>
            <div className={CN.tableHeader}>
              <Icon variant="buildingLibrary" width="lg" /> <div className={CN.headerText}>Received in bank</div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Tuesday</td>
          <td className={CN.focus}>Wednesday</td>
        </tr>
        <tr>
          <td>Wednesday</td>
          <td className={CN.focus}>Thursday</td>
        </tr>
        <tr>
          <td>Thursday</td>
          <td className={CN.focus}>Friday</td>
        </tr>
        <tr>
          <td>Friday</td>
          <td className={CN.focus}>Monday</td>
        </tr>
        <tr>
          <td>Saturday & Sunday</td>
          <td className={CN.focus}>Monday</td>
        </tr>
        <tr>
          <td>Monday</td>
          <td className={CN.focus}>Tuesday</td>
        </tr>
      </tbody>
    </table>
    <div className={CN.subTitle}>
      *You can choose to receive payouts weekly if you prefer, on any day of your choice.
      <br /> Eg receive weekly payouts on Tuesday covering last week{S.apos}s takings from Tuesday to Monday
    </div>
  </div>
);
export default TablePayment;
